import React from 'react'
import _toString from 'lodash/toString'
// import style from '../../style.module.less'
// import {Link} from 'react-router'
const LIVE_TYPE = {
  '1': '全国',
  '2': '本地及周边'
}

const COST_STATUS = {
  '1': ['未出账', '#999999'],
  '2': ['已出帐', '#448AFC'],
  '3': ['交易关闭', '#FF801A'],
  '4': ['退回余额', '#999999'],
  '5': ['直播转包月', '#999999']
}

export default [
  {
    title: '推广范围',
    dataIndex: 'liveType',
    key: 'liveType',
    render: (text, record) => {
      return <div>{LIVE_TYPE[text] || '-'}</div>
    }
  },
  {
    title: '状态',
    dataIndex: 'costStatus',
    key: 'costStatus',
    render: (text, record) => {
      return (
        <div
          style={{
            color: (COST_STATUS[text] && COST_STATUS[text][1]) || '#999999'
          }}
        >
          {(COST_STATUS[text] && COST_STATUS[text][0]) || '-'}
        </div>
      )
    }
  },
  {
    title: '金额（元）',
    dataIndex: 'value',
    key: 'value',
    render: value => {
      if (+value > 0) {
        return `+${_toString(value)}`
      }
      return `${_toString(value)}`
    }
  },
  {
    title: '关联直播',
    dataIndex: 'title',
    key: 'title',
    render: (text, record) => {
      const { costStatus } = record
      return costStatus != 5 ? (
        <a href={'#/localMerchant/liveManage/controlBoard/' + record.liveId}>
          {text}
        </a>
      ) : (
        '-'
      )
    }
  },
  {
    title: '直播开始时间',
    dataIndex: 'startTime',
    key: 'startTime',
    render: (text, record) => {
      const { costStatus } = record
      return costStatus != 5 ? text : '-'
    }
  },
  {
    title: '备注',
    dataIndex: 'message',
    key: 'message'
  }
]
